import React from "react";
import { FaSatelliteDish } from "react-icons/fa";

export default function TvEmptyState({ title, copy }) {
  return (
    <div className="tv-display-empty-state">
      <div className="tv-display-empty-icon">
        <FaSatelliteDish />
      </div>
      <div className="tv-display-empty-title">{title}</div>
      <div className="tv-display-empty-copy">{copy}</div>
    </div>
  );
}
